import { render } from "./SuccessDesignationScreen.vue?vue&type=template&id=433e5b34"
import script from "./SuccessDesignationScreen.vue?vue&type=script&lang=js"
export * from "./SuccessDesignationScreen.vue?vue&type=script&lang=js"

import "./SuccessDesignationScreen.vue?vue&type=style&index=0&id=433e5b34&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__